// Reference board and stance geometry, from surf-coaching sources and a lab
// study of pop-ups (see docs/STANCE.md for citations). Used to draw the board
// around the rider's feet, to guide tape placement, and by the simulator.
//
// The app never scores against these numbers: targets always come from the
// stance the rider records. They exist so diagrams and advice are credible.

export const REFERENCE = {
  /** A ~6′ shortboard — the length of the taped stringer. */
  boardLength: 183,
  /** Widest point of the outline, cm. */
  boardWidth: 50,
  /** Back foot over the fins, about a foot up from the tail. */
  backFootFromTail: 30,
  /** Between foot centres; lab mean 0.63 ± 0.10 m (surfers ~1.73 m tall). */
  stanceWidth: 60,
  /** Front foot angled toward the nose; sources give 30–45°. */
  frontFootDeg: 40,
  /** Back foot roughly square to the stringer (≈90°). */
  backFootDeg: 6,
  /** Thruster fins: distance from the tail of side and centre fins, cm. */
  sideFinFromTail: 27,
  centreFinFromTail: 9,
} as const;

/** Board half-width (cm) at fraction t from tail (0) to nose (1): squash tail, pointed nose. */
export function boardHalfWidth(t: number): number {
  const base = (REFERENCE.boardWidth / 2) * Math.pow(Math.sin(Math.PI * Math.min(1, 0.18 + t * 0.86)), 0.75);
  return t < 0.02 ? Math.max(15, base) : base;
}

/** Tail and nose positions along the stringer, given where the back foot stands. */
export function boardSpan(backFootY: number): { tail: number; nose: number } {
  const tail = backFootY - REFERENCE.backFootFromTail;
  return { tail, nose: tail + REFERENCE.boardLength };
}
